<template>
  <div class="occupancy">
    <div class="occupancy--items">
      <b-row>
        <b-col md="6" class="text-center d-flex">
          <div class="occupancy--title">Adulti</div>
          <div class="occupancy--content ml-2">
            <span @click="remove_adult" class="square-icon pointer">-</span>
            <strong>{{ adults }}</strong>
            <span @click="add_adult" class="square-icon pointer">+</span>
          </div>
        </b-col>

        <b-col md="6" class="text-center d-flex">
          <div class="occupancy--title">Bambini</div>
          <div class="occupancy--content ml-2">
            <span @click="remove_child" class="square-icon pointer">-</span>
            <strong>{{ children.length }}</strong>
            <span @click="add_child" class="square-icon pointer">+</span>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="occupancy--ages mt-1" v-if="children.length">
            <div class="occupancy--content">
              <b-row v-for="(m, index) in children" v-bind:key="index">
                <b-col class="occupancy--age">
                  <div>
                    <span @click="remove_child_by_index(index)" class="square-icon--small pointer"
                      >x</span
                    >
                  </div>
                  <div>
                    <span class="nowrap">Bambino {{ index + 1 }}</span>
                  </div>
                  <b-form-select
                    :options="options"
                    :value="m"
                    @change="
                      (value) => {
                        set_child_age(value, index);
                      }
                    "
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col>
        <b-button class="close" @click="close()">OK</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    max_children: Number,
    max_adults: Number,
  },
  data() {
    return {
      adults: this.$store.state.liveflight.adults, //this.$store.state.liveflight.travelers.filter( function(t) { return t.travelerType == 'ADULT' } ).length,
      children: this.$store.state.liveflight.children, //this.$store.state.liveflight.travelers.filter( function(t) { return t.travelerType == 'SEATED_INFANT' } ),
      options: [
        /*
                {value:17, text:'17 anni'},
                {value:16, text:'16 anni'},
                {value:15, text:'15 anni'},
                {value:14, text:'14 anni'},
                {value:13, text:'13 anni'},
                {value:12, text:'12 anni'},
                */

        // CHILD < 12y HELD_INFANT|SEATED_INFANT < 2y
        { value: 11, text: '11 anni' },
        { value: 10, text: '10 anni' },
        { value: 9, text: '9 anni' },
        { value: 8, text: '8 anni' },
        { value: 7, text: '7 anni' },
        { value: 6, text: '6 anni' },
        { value: 5, text: '5 anni' },
        { value: 4, text: '4 anni' },
        { value: 3, text: '3 anni' },
        { value: 2, text: '2 anni' },
        { value: 1, text: '1 anno' },
        { value: 0, text: '0 anni' },
      ],
    };
  },
  methods: {
    close() {
      this.$emit('close', {});
    },
    updated() {
      this.$emit('updated', {
        adults: this.adults,
        children: this.children,
      });
    },
    add_child() {
      if (this.children.length == this.max_children) return;
      //if(this.children.length == this.adults) return

      let children = this.children;
      children.push(11); // CHILD < 12y
      this.updated();
    },
    remove_child(index) {
      if (this.children.length > 0) {
        let children = this.children;
        children.splice(index, 1);
      }
      this.updated();
    },
    remove_child_by_index(index) {
      let children = this.children;
      children.splice(index, 1);
      this.updated();
    },
    set_child_age(value, index) {
      let children = this.children;
      children[index] = value;
      this.updated();
    },
    add_adult() {
      this.adults = Math.min(this.adults + 1, this.max_adults);
      this.updated();
    },
    remove_adult() {
      this.adults = Math.max(this.adults - 1, 1);
      this.updated();
    },
  },
  mounted() {
    //this.updated() //per inviare direttamente al parent un adulto di default
  },
};
</script>

<style lang="scss">
.occupancy {
  @extend .panel !optional;
  min-width: 280px;
  padding: $grid-gutter-width/2;
  box-shadow: 0px 0.5rem 1rem 0px rgb(0 11 38 / 24%);

  &--content {
    .square-icon {
      padding: 3px 6px;
    }
  }

  &--items {
  }
  &--item {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: $grid-gutter-width/4;
  }
  &--adults {
    // @extend .occupancy--item;
  }
  &--children {
    // @extend .occupancy--item;
    margin-bottom: $grid-gutter-width/2;
  }
  &--ages {
    //@extend .occupancy--item;
    .occupancy--content {
      flex: 1;
    }
    .occupancy--age {
      display: flex;
      align-items: center;
      margin-bottom: $grid-gutter-width/4;
      .square-icon--small {
        margin: 0;
      }
      .nowrap {
        margin: 0 $grid-gutter-width/6;
      }
    }
    .custom-select {
      min-width: 100px;
      padding-left: $grid-gutter-width/2;
      padding-right: $grid-gutter-width;
      max-width: 140px;
      margin-left: 40px;
      text-align: center;
    }
  }

  .btn.close.selected,
  .btn.close:not(.selected) {
    background-color: $tertiary !important;
    color: $white;
    opacity: 1;
    border-radius: $border-radius-sm;
    font-size: $btn-font-size-sm;
    padding: $btn-padding-y-sm $btn-padding-x-lg;
    -webkit-font-smoothing: antialiased;
    @include font-primary-light;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 140%;
    //width: 100%;
    margin-top: 0.5rem;
    transition: $transition-base;
    cursor: pointer;
    &:hover {
      opacity: 0.75;
    }
  }
}
</style>
